import http from 'hub-http/clients/apiClient';
import { getEarlyRequest } from 'automation-ui-core/utils/earlyRequesterUtils';
import FeaturePermissions from 'automation-ui-permissions/feature-permissions/records/FeaturePermissions';
import { formatFeaturePermissionsBySourceApp } from 'automation-ui-permissions/feature-permissions/utils/formatFeaturePermissionsBySourceApp';
const FEATURE_PERMISSIONS_EMBED_REQUEST_KEY = 'feature-permissions-embed';
const FEATURE_PERMISSIONS_BY_FLOW_ID_REQUEST_KEY = 'feature-permissions-by-flow-id';
const FEATURE_PERMISSIONS_REQUEST_KEY = 'feature-permissions';
export const FEATURE_PERMISSIONS_URL = '/automation-access/v1/source-app/access';
export const fetchFeaturePermissions = () => getEarlyRequest({
  key: FEATURE_PERMISSIONS_REQUEST_KEY,
  defaultRequestFn: () => http.get(FEATURE_PERMISSIONS_URL)
}).then(({
  results
}) => formatFeaturePermissionsBySourceApp(results));
export const fetchFeaturePermissionsByFlowId = ({
  flowId
}) => getEarlyRequest({
  key: FEATURE_PERMISSIONS_BY_FLOW_ID_REQUEST_KEY,
  defaultRequestFn: () => http.get(`${FEATURE_PERMISSIONS_URL}/${flowId}`)
}).then(({
  features
}) => new FeaturePermissions(features));
export const fetchEmbedFeaturePermissions = () => getEarlyRequest({
  key: FEATURE_PERMISSIONS_EMBED_REQUEST_KEY,
  defaultRequestFn: () => http.get(`${FEATURE_PERMISSIONS_URL}/scopes-only`)
}).then(({
  features
}) => new FeaturePermissions(features));